<template>
  <li>
    <a href="" @click.prevent="editExecutionRequestTap">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-2 panel-info text-center text-sm-right">
          
          <!-- <div v-else class="d-inline-block" style="width: 24px"></div> -->
          <!-- <span class="text-muted small">الفاتورة: </span> -->
          {{ executionRequest.user.name }}
        </div>

        <div class="col-12 col-sm-6 col-md-6 panel-info text-center text-sm-right">
          {{ executionRequest.body }}
        </div>

        <div class="col-12 col-sm-6 col-md-2 panel-info text-center">
          {{ getDate(executionRequest.updated_at) }}
        </div>

        <div class="col-12 col-sm-6 col-md-2 panel-info text-center text-sm-left" @click.prevent>
          <!-- <button class="btn btn-info btn-sm" @click.prevent="editBillTap">
            <fa icon="edit" />
          </button> -->
        </div>
      </div>

      <div
        v-if="showDetails"
        @click.stop="showDetails = false"
        class="container doc-row-details"
      >
        <div class="row">
          <div class="col-12 text-justify">
            {{ executionRequest.body }}
          </div>
        </div>
      </div>
    </a>
  </li>
</template>

<script>
import ExecutionRequestsMixin from '@/mixins/execution-requests'

export default {
  mixins: [ExecutionRequestsMixin],

  data() {
    return {
      showDetails: false,
    };
  },

  methods: {
    editExecutionRequestTap () {
      this.selectExecutionRequest(this.executionRequest)
      this.$bvModal.show('execution-request-modal')
    },
  },

  props: ["executionRequest"],
};
</script>